"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var r = require("revalidate");
var composeValidators = r.composeValidators;
var combineValidators = r.combineValidators;
var isRequired = r.isRequired;
var matchesPattern = r.matchesPattern;
exports.loginValidator = combineValidators({
    email: composeValidators(isRequired({ message: "emailRequired" }), matchesPattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)({ message: "emailInvalid" }))("email"),
    password: isRequired({ message: "passwordRequired" })
});
//# sourceMappingURL=login.js.map


//////////////////
// WEBPACK FOOTER
// ../validation/build/login/login.js
// module id = 439
// module chunks = 22